<footer class="{{ footerClass }}">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"
                        ><img
                            class="udfLogo"
                            src="assets/img/udf.png"
                            alt="logo"
                    /></a>
                    <p>
                        A collection of cloud-based data technology, modern
                        architecture, data applications, organizational
                        capabilities, and data governance that will drive value
                        for ExxonMobil.
                    </p>
                    <!-- <ul class="social-link">
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul> -->
                </div>
            </div>

            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Explore</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="">Home</a></li>
                        <li><a routerLink="/university">University</a></li>
                        <li><a routerLink="/community-of-practice">CoP</a></li>
                    </ul>
                </div>
            </div>

            <!-- <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Resources</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/data-foundation">Data Foundation</a></li>
                        <li><a routerLink="/platforms">Platforms</a></li>
                        <li><a routerLink="/success-stories">Success Stories</a></li>
                        <li><a routerLink="/platform-status">Platform Status</a></li>
                    </ul>
                </div>
            </div> -->

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Address</h3>
                    <ul class="footer-contact-info">
                        <!-- <li><i class='bx bx-map'></i>175 5th Ave, New York, NY 10010, United States</li> -->
                        <!-- <li><i class='bx bx-phone-call'></i><a href="tel:+44587154756">+1 (123) 456 7890</a></li> -->
                        <li>
                            <i class="bx bx-envelope"></i
                            ><a href="mailto:UDGP-UDFSupport@exxonmobil.com"
                                >&#64;UDF.support</a
                            >
                        </li>
                        <!-- <li><i class='bx bxs-inbox'></i><a href="tel:+557854578964">+55 785 4578964</a></li> -->
                    </ul>
                </div>
            </div>
        </div>

        <!-- <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p><a href="https://envytheme.com/" target="_blank">UDF</a></p>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Privacy Policy</a></li>
                        <li><a routerLink="/">Terms & Conditions</a></li>
                    </ul>
                </div>
            </div>
        </div> -->
    </div>

    <div class="footer-map">
        <img src="assets/img/footer-map.png" alt="image" />
    </div>
</footer>

<div class="go-top"><i class="flaticon-up"></i></div>
